import { useEffect, useRef, useState } from 'react';

const PALETTE = [
  '#ef4444', '#f97316', '#f59e0b', '#eab308',
  '#84cc16', '#22c55e', '#10b981', '#14b8a6',
  '#06b6d4', '#3b82f6', '#6366f1', '#8b5cf6',
  '#a855f7', '#d946ef', '#ec4899', '#64748b',
];

export default function NewCategoryForm({ onAddCategory, onCancel }) {
  const [name, setName] = useState('');
  const [color, setColor] = useState('#6366f1');
  const [isPaletteOpen, setIsPaletteOpen] = useState(false);
  const pickerRef = useRef(null);

  useEffect(() => {
    if (!isPaletteOpen) return undefined;
    const onDocClick = (e) => {
      if (pickerRef.current && !pickerRef.current.contains(e.target)) {
        setIsPaletteOpen(false);
      }
    };
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('touchstart', onDocClick);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('touchstart', onDocClick);
    };
  }, [isPaletteOpen]);

  const handleSubmit = (event) => {
    event.preventDefault();
    onAddCategory(name.trim(), color);
    setName('');
  };

  const pickColor = (c) => {
    setColor(c);
    setIsPaletteOpen(false);
  };

  return (
    <form className="new-category-form" onSubmit={handleSubmit}>
      <input
        value={name}
        onChange={(event) => setName(event.target.value)}
        placeholder="Название категории..."
        autoFocus
      />
      <div className="color-picker-wrap" ref={pickerRef}>
        <button
          type="button"
          className="color-picker-trigger"
          onClick={() => setIsPaletteOpen((v) => !v)}
          aria-label="Выбор цвета"
        >
          <span className="color-picker-swatch" style={{ background: color }} />
          <span className="color-picker-hint">Выбор цвета</span>
        </button>
        {isPaletteOpen && (
          <div className="color-picker-palette" role="listbox" aria-label="Палитра">
            {PALETTE.map((c) => (
              <button
                key={c}
                type="button"
                className={'color-picker-cell' + (c === color ? ' is-active' : '')}
                style={{ background: c }}
                onClick={() => pickColor(c)}
                aria-label={c}
              />
            ))}
          </div>
        )}
      </div>
      <button className="secondary-button" type="submit">Создать</button>
      <button className="secondary-button" type="button" onClick={onCancel}>Отмена</button>
    </form>
  );
}
